module.exports = __webpack_public_path__ + "img/恭喜获得.5cd54eda.gif";